<template>
  <div id="stock-in">
    <b-card>
      <b-row>
        <b-col md="6">
        <h3>{{ $route.name }}</h3>

        <!-- breadcrumb -->
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item to="/inventory/stock-in/" active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <!-- end breadcrumb -->
      </b-col>

      <b-col md="6">
        <b-button variant="primary" :to="'stock-in/create'" class="float-right btn-custom"
          ><font-awesome-icon icon="plus"
        /></b-button>
      </b-col>
      </b-row>
      <paginated-table
      ref="dataTable"
      :can-edit="false"
      :can-delete="false"
      :can-approve="false"
      :can-reject="false"
      :can-show="true"
      :can-edit-modal="true"
      :can-paid="false"
      :data-url="apiUrl.stockIn"
      :data-key="dataKey"
      :data-columns="columns"
      ></paginated-table>
    </b-card>
  </div>
</template>
<script>
import PaginatedTable from '../../../components/PaginatedTable.vue'
export default {
  components: { PaginatedTable },
  data(){
    return {
      dataKey: 'stock_in',
      apiUrl: {
        stockIn: window.AppConfig.apiUrl + 'stock-in?limit=25'
      },
      model:{
        stockInId: null,
        stockInDate: null,
        stockInNote: null,
        stockArea: null,
        journalAccount: null,
        stockInItem: null,
        stockInItemNote: null,
        stockInItemQuantity: null,
        stockInItemPrice: null,
        itemList: null,
        stockIn: null,
      },
      columns: [
        {
          key: 'stockInId',
          label: 'Stock In Id',
          sortable: true
        },
        {
          key: 'stockInDate',
          label: 'Stock In Date',
          sortable: true
        },
        {
          key: 'stockInNote',
          label: 'Stock In Note',
          sortable: true
        },
        {
          key: 'stockArea.areaName',
          label: 'Stock Area',
          sortable: true
        },
        // {
        //   key: 'stockInItem[0].stockInItemPrice',
        //   label: 'Stock In Item Price',
        //   sortable: true
        // },
        {
          key: 'actionStockIn',
          label: '',
          sortable: true
        },
      ]
    }
  }
}
</script>